module.exports = __webpack_public_path__ + "static/img/irole.771796f.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/mz/irole.png
// module id = 6l7c
// module chunks = 7